import React, { useEffect, useState } from 'react'
import { Table } from '../../components/Table/Table'
import { active_img, deactive_img, delete_icon, edit_icon, eye_icon, left_arrow, password_icon, search_icon, toggle_off, toggle_on, user_profile, view_icon } from '../../assets/imgs';
import { useLocation, useNavigate } from 'react-router-dom';
import { admin_list } from '../redux/api/dummyJson';
import CancelIcon from '@mui/icons-material/Cancel';
import { useLazyRoomListQuery, useLazyRoomViewQuery, useRoomListAddMutation, useRoomListMutation, useRoomListStatusMutation, useRoomListUpdateMutation } from '../redux/api/api';
import { toast } from 'react-toastify';

const RoomCategory = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [popup, setPopup] = useState(false);
    const [list, setList] = useState([]);
    const [id, setId] = useState();
    const [type, setType] = useState();
    const [name, setName] = useState();
    const [pageno, setPageno] = useState(1);
    const [pagecount, setPagecount] = useState("");
    const [loader, setLoader] = useState(false);

    const rolePermissions = JSON.parse(localStorage.getItem('permissions'))

    const [roomListApi] = useRoomListMutation();
    const [roomStatusApi] = useRoomListStatusMutation();
    const [roomAddApi] = useRoomListAddMutation();
    const [roomEditApi] = useRoomListUpdateMutation();
    const [roomViewApi] = useLazyRoomViewQuery();



    const roomList = (pageno, search) => {
        const formdata = new FormData();
        formdata.append("type", 1)
        formdata.append("page", pageno)
        formdata.append("row", 10)
        if (search) {
            formdata.append('search', search)
        }
        roomListApi(formdata)
            .unwrap()
            .then((res) => {
                console.log("res", res);
                let temp = []
                res?.categories?.map((item, ind) => {
                    let obj = { ...item }
                    obj.current_page = res?.pagination?.current_page
                    temp.push(obj)
                })
                setList(temp);
                setPagecount(res?.pagination)
            })
            .catch((err) => {
                console.log("err", err);
            })
    }

    const roomStatus = (id) => {
        const formdata = new FormData();
        formdata.append("id", id);
        roomStatusApi(id)
            .unwrap()
            .then((res) => {
                console.log("res", res);
                if (res?.status == "success") {
                    toast(res?.message);
                    roomList();
                }
            })
            .catch((err) => {
                console.log("err", err);
            })
    }

    const roomAdd = () => {
        if (!name) {
            toast.error("Enter Name");
            return;
        }
        const formdata = new FormData();
        formdata.append("type", 1)
        formdata.append("name", name);
        setLoader(true);
        roomAddApi(formdata)
            .unwrap()
            .then((res) => {
                console.log("res", res);
                if (res?.status == "success") {
                    setLoader(false);
                    setPopup(false);
                    toast.success(res?.message);
                    roomList(pageno);
                    setName("");
                }
            })
            .catch((err) => {
                console.log("err", err);
            }).finally(() => {
                setLoader(false);
            })
    }
    const roomEdit = () => {
        if (!name) {
            toast.error("Enter Name");
            return;
        }
        const formdata = new FormData();
        formdata.append("type", 1)
        formdata.append("id", id);
        formdata.append("name", name);
        setLoader(true);
        roomEditApi({ payload: formdata, id: id })
            .unwrap()
            .then((res) => {
                console.log("res", res);
                if (res?.status == "success") {
                    setLoader(false);
                    setPopup(false);
                    toast.success(res?.message);
                    roomList();
                    setName("");
                }
            })
            .catch((err) => {
                console.log("err", err);
            }).finally(() => {
                setLoader(false);
            })
    }
    const roomView = (id) => {
        roomViewApi(id)
            .unwrap()
            .then((res) => {
                console.log("res", res);
                if (res?.category) {
                    setPopup(true);
                    setType("edit");
                    setName(res?.category?.name);
                }
            })
            .catch((err) => {
                console.log("err", err);
            })
    }




    useEffect(() => {
        roomList(pageno)
    }, [pageno]);


    const columns = React.useMemo(
        () => [
            {
                Header: "S.No",
                accessor: "",
                Cell: ({ value, row }) => {
                    return <p>{(row?.original?.current_page - 1) * 10 + row.index + 1}</p>;
                }
            },

            {
                Header: "Category",
                accessor: "name",
                Cell: ({ value, row }) => {
                    return <p>{value}</p>;
                },
            },
            {
                Header: "Status",
                accessor: "status",
                Cell: ({ value, row }) => {
                    return (
                        <React.Fragment>
                            <select disabled={rolePermissions?.includes('CAN-STATUS-MASTER') ? false : true}
                                value={value}
                                onChange={() => roomStatus(row.original.id)}
                                className={`fs-sm-10 fs-md-11 fs-lg-12 fs-xl-14 fs-xxl-16 ${value == 1 ? "active-btn" : "suspend-btn"}`}
                            >
                                <option className="fs-sm-10 fs-md-11 fs-lg-12 fs-xl-14 fs-xxl-16 bg-white black" value={1}>
                                    Active
                                </option>
                                <option className="fs-sm-10 fs-md-11 fs-lg-12 fs-xl-14 fs-xxl-16 bg-white black" value={0}>
                                    Deactive
                                </option>
                            </select>
                        </React.Fragment>
                    );
                },
            },
            {
                Header: "Action",
                accessor: "",
                Cell: ({ value, row }) => {
                    return (
                        <React.Fragment>
                            <div className="d-flex ac-jc">
                                {rolePermissions?.includes('CAN-EDIT-MASTER') &&
                                    <button
                                        onClick={() => { roomView(row.original.id); setId(row.original.id); setType("edit"); }}
                                        className="cust-btn "
                                    >
                                        <img src={edit_icon} alt="" className="mx-2 edit-btn " />
                                    </button>}
                            </div>
                        </React.Fragment>
                    );
                },
            },
        ],
        []
    );


    return (
        <div className="dashRightView home_section" >
            <div className='d-flex ac-jb'>
                <h2 className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 sec">
                    Masters - Room Category
                </h2>
                <div className='d-flex gap-3'>
                    < div className='search-input'>
                        <input type='text' onChange={(e) => roomList(1, e.target.value)} placeholder='Search' style={{ border: 'none', width: '150px' }} />
                        <img src={search_icon} className='search' />
                    </div>
                    {rolePermissions?.includes('CAN-ADD-MASTER') &&
                        <button onClick={() => { setPopup(true) }} className='f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 white add-btn '> + Add </button>}
                </div>
            </div>

            <div>
                <Table columns={columns} data={list} setPageno={setPageno} pagecount={pagecount} show={true} />
            </div>

            {popup && (
                <div className="img-popup-design">
                    <div className="img-popup">
                        <div className='d-flex ac-je'  >
                            <button className='cust-btn' onClick={() => { setPopup(false); setName("") }}>
                                <CancelIcon />
                            </button>
                        </div>
                        <h4 className="f1 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                            Category Name
                        </h4>
                        <input type="text" value={name} onChange={(e) => setName(e.target.value)} className="input-pop ps-2 w-100" placeholder="Category Name" />

                        <div style={{ textAlign: 'center', marginTop: '30px' }}>
                            <button onClick={() => { type == "edit" ? roomEdit() : roomAdd() }} className="login-btn f2 fs-sm-10 fs-md-8 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3 "  >
                                {loader && (
                                    <div
                                        class="spinner-border spinner-border-sm "
                                        role="status"
                                        style={{ marginRight: "5px" }}
                                    ></div>
                                )} Submit
                            </button>
                        </div>
                    </div>
                </div>
            )}


        </div>
    )
}

export default RoomCategory